import Api from "../../axios"

export const postRejectLeaveRequest = async ({id, reason})=>{
    return await Api.post('/reject_leave',{
        application_id: id,
        reason
    })
}